(function () {

  'use strict';

  function pxWorkflowOutputDocument($filter, EnumerationService, IMAGE_QUALITY, OUTPUTDOCUMENT_FILETYPE, PDF_COMPATIBILITY, PDF_IMAGE_QUALITY) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowFormModel: '=',
        fileNameFormModel: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/outputDocument/workflowOutputDocument.template.html',
      link: function (scope, element, attrs) {

        const OCR_LANGUAGES = EnumerationService.enums.OCRLanguage.map(language => {
          return {
            id: language.id,
            isSelected: false,
            name: (name => {
              const readableName = name.replace(/_/g, ' ');
              return readableName.charAt(0).toUpperCase() + readableName.substr(1).toLowerCase();
            })(language.name)
          };
        });

        OCR_LANGUAGES.forEach((language, index) => {
          if (language.id === 'AUTO') {
            language.name = $filter('translate')('SelectAutomatically');
            OCR_LANGUAGES.splice(index, 1);
            OCR_LANGUAGES.unshift(language);
          }
        });

        scope.OCR_LANGUAGES = OCR_LANGUAGES;

        scope.selectPlaceHolder = 'Select';

        scope.setOutputDocumentFileType = function (item) {
          scope.workflowFormModel.fileType = item.fileType;
          scope.workflowFormModel.isImageOnlyPdf = item.isImageOnlyPdf;
          scope.fileNameFormModel.updateFileNameExample();
        };

        scope.ocrDisplayName = function (ocrLanguage) {
          return scope.OCR_LANGUAGES.find(ocr => ocr.id === ocrLanguage).name;
        };

        scope.removeOCRLanguage = function (ocrLanguage) {
          const index = scope.workflowFormModel.ocrConfiguration.languages.indexOf(ocrLanguage);
          scope.workflowFormModel.ocrConfiguration.languages.splice(index, 1);
          if (scope.workflowFormModel.ocrConfiguration.languages.length < 1) {
            scope.workflowFormModel.ocrConfiguration.languages[0] = 'ENGLISH';
          }
        };

        scope.setItemOnModel = function (item, model, attr) {
          scope.workflowFormModel[model][attr] = item.id;
        };

        scope.openDialog = function (event, dialog) {
          event.preventDefault();
          scope.closeDialog();
          switch (dialog) {
            case 'SELECT_OCR_LANGUAGES':
              scope.dialog = dialog;
              break;
          }
        };

        scope.closeDialog = function () {
          scope.context = null;
          scope.dialog = null;
        };

        scope.showTooltip = function (showTip, position, type, context) {
          if (showTip) {
            scope.tooltipContent = { type, context };
            scope.tooltipObject = { position: { left: position.startX - 15, top: position.startY + 20 } };
          } else {
            scope.tooltipContent = null;
            scope.tooltipObject = null;
          }
        };

        function setSelectOptions() {
          scope.OUTPUTDOCUMENT_SETTINGS = {
            setting: {
              OUTPUTDOCUMENT_FILETYPE: OUTPUTDOCUMENT_FILETYPE.find(item =>
                scope.workflowFormModel.fileType === item.fileType &&
                scope.workflowFormModel.isImageOnlyPdf === item.isImageOnlyPdf)
            },
            selectable: {
              OUTPUTDOCUMENT_FILETYPE: OUTPUTDOCUMENT_FILETYPE
            }
          };

          scope.GENERATE_SEARCHABLE_PDF_SETTINGS = {
            setting: {
              PDF_IMAGE_QUALITY: PDF_IMAGE_QUALITY.find(item => item.id === scope.workflowFormModel.GENERATE_SEARCHABLE_PDF.imageQuality),
              PDF_COMPATIBILITY: PDF_COMPATIBILITY.find(item => item.id === scope.workflowFormModel.GENERATE_SEARCHABLE_PDF.pdfCompatibility)
            },
            selectable: {
              PDF_IMAGE_QUALITY: PDF_IMAGE_QUALITY,
              PDF_COMPATIBILITY: PDF_COMPATIBILITY,
              OCR: OCR_LANGUAGES
            }
          };

          scope.GENERATE_DOCX_SETTINGS = {
            setting: {
              DOCX_IMAGE_QUALITY: IMAGE_QUALITY.find(item => item.id === scope.workflowFormModel.GENERATE_DOCX.imageQuality)
            },
            selectable: {
              DOCX_IMAGE_QUALITY: IMAGE_QUALITY,
              OCR: OCR_LANGUAGES
            }
          };
        }

        setSelectOptions();
      }
    };
  }

  pxWorkflowOutputDocument.$inject = ['$filter', 'EnumerationService', 'IMAGE_QUALITY', 'OUTPUTDOCUMENT_FILETYPE', 'PDF_COMPATIBILITY', 'PDF_IMAGE_QUALITY'];

  angular
    .module('printix-admin')
    .directive('pxWorkflowOutputDocument', pxWorkflowOutputDocument);

})();
